module.exports = __webpack_public_path__ + "img/DNI-ALFY-Dorso-Ejemplo.c908ad27.jpg";